import * as React from 'react';
import { IconProps } from '../types';

const IcUpload = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M11.25 17V6.812L8 10.063 6.25 8.25 12.5 2l6.25 6.25L17 10.063l-3.25-3.25V17h-2.5ZM5 22a2.407 2.407 0 0 1-1.766-.734A2.407 2.407 0 0 1 2.5 19.5v-3.75H5v3.75h15v-3.75h2.5v3.75c0 .688-.245 1.276-.734 1.766-.49.49-1.078.734-1.766.734H5Z"
    />
  </svg>
);

export default IcUpload;
